// extracted by mini-css-extract-plugin
export var actions = "_te-4";
export var item = "_te-1";
export var price = "_te-3";
export var quantity = "_te-2";
export var table = "_te-0";